import React, { FormEvent, useState } from 'react';
import { Button, FormControl, Typography } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import { gql, useMutation } from '@apollo/client';
import { compose, withProps } from 'recompose';
// @ts-ignore
import PhoneInput from '@/se/components/inputs/PhoneInput';
import { withLabel } from '@/se/components/Label';

interface CaretakerPhoneFormProps {
  procedureId: number;
  onDone: () => void;
}

const CaretakerPhoneForm = ({ procedureId, onDone }: CaretakerPhoneFormProps) => {
  const [phoneNumber, setPhoneNumber] = useState('');

  const [setCaretakerPhone, { loading: busy }] = useMutation(gql`
    mutation setCaretakerPhone($procedureId: Long!, $phoneNumber: String!) {
      setCaretakerPhone(procedureId: $procedureId, phoneNumber: $phoneNumber)
    }
  `);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    try {
      await setCaretakerPhone({
        variables: {
          procedureId,
          phoneNumber,
        },
      });
      onDone();
    } catch (e) {
      console.error(e);
    }
  };

  const handleReset = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    onDone();
  };

  return (
    <Box textAlign="center" display="flex" flexDirection="column" justifyContent="middle" maxWidth="62ch">
      <Typography variant="h5" gutterBottom>
        Caretaker Info
      </Typography>
      <Typography gutterBottom>Please enter the phone number of the person taking care of you today.</Typography>
      <Box
        flexDirection="column"
        component="form"
        onSubmit={handleSubmit}
        onReset={handleReset}
        display="flex"
        justifyContent="center"
        textAlign="left"
        mt={2}
      >
        <FormControl variant="outlined" style={{ flex: 3 }}>
          <PhoneNumberInput value={phoneNumber} onChange={value => setPhoneNumber(value.trim())} disabled={busy} />
        </FormControl>
        <Box display="flex" flexDirection="column">
          <Button size="large" type="submit" variant="contained" color="primary">
            Submit
          </Button>
        </Box>
        <Box display="flex" flexDirection="column">
          <Button size="large" type="reset" variant="text" color="secondary">
            Skip
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default CaretakerPhoneForm;

const PhoneNumberInput = compose(
  withLabel('Caretaker Phone Number'),
  withProps({ placeholder: 'e.g., (619) 412-9512' })
)(PhoneInput);
